<div [class]="additionalClasses()" class="flex items-center p-4">
  @if (iconImg() && iconColor()) {
    <i-lucide [img]="iconImg()" [color]="iconColor()" />
  } @else if (iconImg()) {
    <i-lucide [img]="iconImg()" />
  }
  <span class="pl-2 text-xl">{{ title() }}</span>
</div>
